// Color conversion helpers shared between the circle/rect opacity controls.

// Convert a #rrggbb hex string to an rgba() string with the given alpha.
export const hexToRgba = (hex, alpha = 1) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, ${alpha})`
    : 'rgba(0, 0, 0, 1)';
};

// Extract the #rrggbb portion from an rgb()/rgba() string.
export const extractHexFromRgba = (rgba) => {
  const rgbMatch = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
  if (rgbMatch) {
    const r = parseInt(rgbMatch[1]).toString(16).padStart(2, '0');
    const g = parseInt(rgbMatch[2]).toString(16).padStart(2, '0');
    const b = parseInt(rgbMatch[3]).toString(16).padStart(2, '0');
    return `#${r}${g}${b}`;
  }
  return '#000000';
};

// Extract the alpha (0–1) from an rgba() string, defaulting to 0.7.
export const extractOpacityFromRgba = (rgba) => {
  // Only a true 4-component rgba() carries an alpha; rgb() falls back to default.
  const opacityMatch = rgba.match(
    /rgba\(\s*[\d.]+\s*,\s*[\d.]+\s*,\s*[\d.]+\s*,\s*([\d.]+)\s*\)/
  );
  if (opacityMatch) {
    return parseFloat(opacityMatch[1]);
  }
  return 0.7;
};

// Replace the alpha channel of an rgb()/rgba() string, keeping its rgb values.
export const setRgbaOpacity = (rgba, alpha) => {
  const match = rgba.match(/rgba?\(([^)]+)\)/);
  if (!match) return rgba;
  const parts = match[1].split(',');
  const r = parseInt(parts[0].trim());
  const g = parseInt(parts[1].trim());
  const b = parseInt(parts[2].trim());
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
